import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/cn';

type TypographyProps = HTMLAttributes<HTMLElement> & {
  children: ReactNode;
};

export function Title({ children, className, ...props }: TypographyProps) {
  return (
    <h1 className={cn('text-[48px] font-bold leading-[1.08] tracking-[-0.02em] text-white sm:text-[72px] sm:leading-[80px]', className)} {...props}>
      {children}
    </h1>
  );
}

export function Body({ children, className, ...props }: TypographyProps) {
  return (
    <p className={cn('text-[16px] leading-[1.6] text-[#94A3B8]', className)} {...props}>
      {children}
    </p>
  );
}

export function Headline({ children, className, ...props }: TypographyProps) {
  return (
    <h2 className={cn('text-[32px] font-semibold leading-[1.2] tracking-[-0.02em] text-white', className)} {...props}>
      {children}
    </h2>
  );
}

export function Caption({ children, className, ...props }: TypographyProps) {
  return (
    <p className={cn('text-[13px] leading-snug text-[#64748B]', className)} {...props}>
      {children}
    </p>
  );
}
